<template>
  <div class="payment-method-btn">
    <button class="lyt-soft-btn w-100" data-bs-toggle="modal" :data-bs-target="`#staticCurrencyBackdrop-${rowData.id}`">
      {{ rowData.name }} ({{ rowData.CurrencySymbol }})
    </button>

    <div class="modal fade" :id="`staticCurrencyBackdrop-${rowData.id}`" data-bs-backdrop="static"
         data-bs-keyboard="false"
         tabindex="-1" :aria-labelledby="`staticCurrencyBackdrop-${rowData.id}Label`" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title" :id="`staticCurrencyBackdrop-${rowData.id}Label`">Sale Details in
              {{ rowData.CurrencyName }} ({{ rowData.CurrencySymbol }})</h6>
            <a type="button" class="btn-close" data-bs-dismiss="modal" :id="`closeCurrency-${rowData.id}-Dialog`"
               aria-label="Close"></a>
          </div>
          <div class="modal-body">
            <div class="sale-lines-table">
              <ul class="sales-list">
                <li :key="index" v-for="(sale , index) in currentSaleLines">
                  <ForeignCurrencySaleLine :sale="sale" :symbol="rowData.CurrencySymbol" :rate="rowData.CurrencyRate"/>
                </li>
              </ul>
            </div>
          </div>

          <div class="modal-footer">
            <ForeignSaleDetails :rate="rowData.CurrencyRate" :symbol="rowData.CurrencySymbol" />
            <a type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</a>
            <a type="button" class="btn btn-primary" @click="$emit(`click`)">Process Transaction</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import ForeignCurrencySaleLine from "@/components/point-of-sale/sales/payment/ForeignCurrencySaleLine";
import ForeignSaleDetails from "@/components/point-of-sale/sales/ForeignSaleDetails";

export default {
  name: 'ForeignCurrency',
  components: {ForeignSaleDetails, ForeignCurrencySaleLine},
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },

  computed: {
    currentSale() {
      return this.$store.getters.getCurrentSale
    },
    currentSaleLines() {
      return this.$store.getters.getSaleLines
    },
  },
  data() {
    return {}
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.modal-backdrop {
  z-index: -1;
}

// Removed the generic button styling as lyt-soft-btn is now globally defined
/*
button {
  color: white;
  font-size: 18px;
  font-weight: 700;
  font-family: 'Inter', sans-serif;
  border-radius: 8px;
  height: 90%;
  width: 75%;
  max-width: 600px;
}
*/

.modal-content {
  background-color: var(--card-bg); /* Consistent background */
  border: 1px solid var(--card-border); /* Consistent border */
  border-radius: 15px; /* Larger border-radius */
  box-shadow: var(--card-shadow); /* Consistent shadow */
  color: var(--text-primary); /* Default text color */
  transition: var(--transition-speed); /* Consistent transition */
}

.modal-header {
  background-color: var(--bg-primary); /* Slightly different background for header */
  border-bottom: 1px solid var(--card-border); /* Consistent border */
  padding: 15px 20px; /* Adjusted padding */

  .modal-title {
    color: var(--text-primary); /* Consistent text color */
    font-weight: 700; /* Bolder font */
    font-size: 1.15rem; /* Slightly larger font */
  }

  .btn-close {
    filter: var(--btn-close-filter); /* Apply filter for dark mode visibility */
  }
}

.modal-body {
  padding: 20px; /* Adjusted padding */
}

.modal-footer {
  background-color: var(--bg-primary); /* Consistent background */
  border-top: 1px solid var(--card-border); /* Consistent border */
  padding: 15px 20px; /* Adjusted padding */
  display: flex;
  justify-content: flex-end;
  gap: 10px; /* Space between buttons */

  .btn-secondary {
    background-color: var(--secondary-button-bg); /* Consistent secondary button bg */
    color: var(--secondary-button-text); /* Consistent secondary button text color */
    border: 1px solid var(--secondary-button-border); /* Consistent border */
    border-radius: 10px; /* Consistent border-radius */
    padding: 10px 20px; /* Adjusted padding */
    font-weight: 600;
    transition: var(--transition-speed);

    &:hover {
      background-color: var(--secondary-button-hover-bg); /* Darker on hover */
      box-shadow: var(--card-shadow-sm); /* Subtle shadow */
    }
  }

  .btn-primary {
    background: linear-gradient(135deg, var(--accent-electric-blue), var(--accent-neon-purple)); /* Consistent primary button gradient */
    color: white;
    border: none;
    border-radius: 10px; /* Consistent border-radius */
    padding: 10px 20px; /* Adjusted padding */
    font-weight: 600;
    transition: var(--transition-speed);

    &:hover {
      background: linear-gradient(135deg, var(--accent-electric-blue-dark), var(--accent-neon-purple-dark)); /* Darker gradient on hover */
      box-shadow: var(--card-shadow-sm); /* Subtle shadow */
    }
  }
}

.payment-method-btn {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 0; /* Remove margin-bottom as it's typically handled by parent layout */
  height: auto; /* Let button height be determined by lyt-soft-btn */
}

.sales-list {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    border: 1px solid var(--card-border); /* Consistent border color */
    border-radius: 10px; /* Consistent border-radius */
    margin-bottom: 10px; /* Space between items */
    overflow: hidden; /* Ensure content stays within bounds */

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>